import script from "./category-area.vue?vue&type=script&setup=true&lang=js"
export * from "./category-area.vue?vue&type=script&setup=true&lang=js"

import "./category-area.vue?vue&type=style&index=0&id=78c16a54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c16a54"]])

export default __exports__